
  import createMeisterIcons from '../src/createMeisterIcons';

  const MinusBlock = createMeisterIcons("minus-block", [["path",{"fill":"currentColor","d":"M4.3 9.75a.575.575 0 0 0-.55.55v3.4c0 .366.24.55.45.55h15.5c.286 0 .55-.264.55-.55v-3.4a.575.575 0 0 0-.55-.55zm-2.05.55c0-1.114.936-2.05 2.05-2.05h15.4c1.114 0 2.05.936 2.05 2.05v3.4c0 1.114-.936 2.05-2.05 2.05H4.2c-1.19 0-1.95-1.016-1.95-2.05z","key":"5a224112b801cc82e270ec956369ba710a7ad8a9","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default MinusBlock
  